import './init-text-node-config';
import { setMessageGenerateFunc, setUnknownMessageConfig, setInvalidMessageConfig, setRevokeMessageConfig } from '@/business/chat/generate-message-config';
import { MsgL2Type, MixedMsgItem } from '_c/typings/proto';
import TextMessageView from '@/component/message/text/index.vue';
import PicMessageView from '@/component/message/pic/index.vue';
import MarkdownMessageView from '@/component/message/markdown/index.vue';
import UnknownMessageView from '@/component/message/unknown/index.vue';
import RevokeMessageView from '@/component/message/revoke/index.vue';
import InvalidMessageView from '@/component/message/invalid/index.vue';
import SystemMessageView from '@/component/message/system/index.vue';
import CustomMessageView from '@/component/message/custom/main';
import StickerMessageView from '@/component/message/sticker/index.vue';
import MixedMessageView from '@/component/message/mixed/index.vue';
import TopicMessageView from '@/component/message/topic/index.vue';
import { extractTextNodeConfigList } from '@/business/chat/generate-text-node-config';
import { operationSettingMap } from '@/business/chat/message-operate-config';
import { EOperationType } from '_c/typings/model/chat/message-operate';
export function validateMixed(msgTypeList: MixedMsgItem[], text: string): boolean {
  let hasText = false;
  let isValidate = true;
  msgTypeList.forEach((item) => {
    if (item.l2Type === 1 && !hasText) {
      hasText = true;
    }
  });
  if (hasText && !text) {
    isValidate = false;
  }
  return isValidate;
}

/**
 * 生成不合法消息
 */
setInvalidMessageConfig(() => ({
  component: InvalidMessageView,
  props: {},
  needBaseStyle: true,
  canShowReaction: false,
  isUnknown: false,
  supportOperate: [],
}));

/**
 * 生成未知消息
 */
setUnknownMessageConfig(() => ({
  component: UnknownMessageView,
  props: {},
  needBaseStyle: true,
  canShowReaction: false,
  isUnknown: true,
}));

/**
 * 生成撤回消息
 */
setRevokeMessageConfig(() => ({
  component: RevokeMessageView,
  props: {},
  needBaseStyle: false,
  canShowReaction: false,
  isUnknown: false,
}));

/**
 * 生成文字消息
 */
setMessageGenerateFunc(MsgL2Type.MsgL2TypeText, (messageData) => {
  const textNodeConfigList = extractTextNodeConfigList(messageData.content);
  return {
    component: TextMessageView,
    props: {
      text: messageData.content,
      textNodeConfigList,
    },
    isValid: !!messageData.content.trim() && textNodeConfigList.every(item => item.isValid),
    supportOperateList: [
      operationSettingMap[EOperationType.reaction],
      operationSettingMap[EOperationType.reply],
      operationSettingMap[EOperationType.copy],
      // 一期先屏蔽举报功能
      // operationSettingMap[EOperationType.report],
      operationSettingMap[EOperationType.cancel],
      // operationSettingMap[EOperationType.top],
    ],
  };
});

/**
 * 生成图片消息
 */
setMessageGenerateFunc(MsgL2Type.MsgL2TypePic, messageData => ({
  component: PicMessageView,
  props: {
    picInfo: messageData.picInfo,
  },
  isValid: Array.isArray(messageData.picInfo) && messageData.picInfo.length > 0,
  supportOperateList: [
    operationSettingMap[EOperationType.reaction],
    operationSettingMap[EOperationType.reply],
    // 一期先屏蔽举报功能
    // operationSettingMap[EOperationType.report],
    operationSettingMap[EOperationType.add],
    operationSettingMap[EOperationType.cancel],
    // operationSettingMap[EOperationType.top],
  ],
}));

/**
 * 生成涂鸦消息
 */
setMessageGenerateFunc(MsgL2Type.MsgL2TypeGraffiti, messageData => ({
  component: PicMessageView,
  props: {
    picInfo: messageData.graffitiMsg?.picInfo,
  },
  isValid: !!messageData.graffitiMsg,
  supportOperateList: [
    operationSettingMap[EOperationType.reaction],
    operationSettingMap[EOperationType.reply],
    operationSettingMap[EOperationType.add],
    operationSettingMap[EOperationType.cancel],
  ],
}));
/**
 * 生成markdown消息
 */
setMessageGenerateFunc(MsgL2Type.MsgL2TypeMarkdown, messageData => ({
  component: MarkdownMessageView,
  props: {
    text: messageData.content,
  },
  isValid: !!messageData.content.trim(),
  supportOperateList: [
    operationSettingMap[EOperationType.reaction],
    operationSettingMap[EOperationType.reply],
  ],
}));

/**
 * 生成自定义表情消息
 */
setMessageGenerateFunc(MsgL2Type.MsgL2TypeSticker, messageData => ({
  component: StickerMessageView,
  isValid: !!messageData.stickerMsg,
  supportOperateList: [
    operationSettingMap[EOperationType.reaction],
    operationSettingMap[EOperationType.reply],
    operationSettingMap[EOperationType.add],
    // 一期先屏蔽举报功能
    // operationSettingMap[EOperationType.report],
    operationSettingMap[EOperationType.cancel],
    // operationSettingMap[EOperationType.top],
  ],
}));

/**
 * 生成系统消息
 */
setMessageGenerateFunc(MsgL2Type.MsgL2TypeSystem, messageData => ({
  component: SystemMessageView,
  isValid: !!messageData.systemMsg,
  canShowReaction: false,
  needBaseStyle: false,
}));
/**
 * 生成混合消息
 */
setMessageGenerateFunc(MsgL2Type.MsgL2TypeMixed, (messageData) => {
  const textNodeConfigList = extractTextNodeConfigList(messageData.content);
  const msgTypeList = messageData.mixedMsg?.msgItemList as MixedMsgItem[];
  const { picInfo } = messageData;
  const text = messageData.content;
  const validateRes = validateMixed(msgTypeList, text);
  return {
    component: MixedMessageView,
    props: {
      msgTypeList,
      picInfo,
      text,
      textNodeConfigList,
    },
    isValid: !!messageData.mixedMsg && validateRes,
    canShowReaction: true,
    needBaseStyle: true,
  };
});

/**
 * 生成话题消息
 */
setMessageGenerateFunc(MsgL2Type.MsgL2TypeTopicStructured, messageData => ({
  component: TopicMessageView,
  props: {
    topicData: messageData.topicStructuredMsg,
  },
  supportOperateList: [
    operationSettingMap[EOperationType.reaction],
    operationSettingMap[EOperationType.reply],
    operationSettingMap[EOperationType.cancel],
    // operationSettingMap[EOperationType.top],
  ],
  isValid: !!messageData.topicStructuredMsg,
  canShowReaction: true,
  needBaseStyle: true,
}));

/**
 * 生成自定义消息
 */
setMessageGenerateFunc(MsgL2Type.MsgL2TypeCustomStructured, messageData => ({
  component: CustomMessageView,
  props: {
    customInfo: messageData.content,
    reportInfo: {
      toUid: messageData.senderUid,
      userType: messageData.senderUserInfo?.userType,
      messageId: messageData.origin?.ID,
    },
  },
  isValid: !!messageData.content,
  canShowReaction: true,
  needBaseStyle: true,
  supportOperateList: [
    operationSettingMap[EOperationType.reaction],
    operationSettingMap[EOperationType.reply],
  ],
}));
